// P25 / Lauf 3 — E5c: die Redirect-Vorwelle wird GEDREHT (docs/30 §8.4).
//
// Bis P24 leitete diese Tabelle RÜCKWÄRTS (neue /world/:type[/:id]-Pfade ->
// heutige Altpfade) — das war nur die Rollback-Brücke, damit ein Rückfallstand
// die neuen Deep-Links versteht. Ab E5c sind die /world/:type[/:id]-Pfade
// KANONISCH (WorldSplit + WorldElementRoute in routes.tsx), also leitet diese
// Tabelle jetzt VORWÄRTS: die Altpfade -> kanonische neue URLs.
//
// Der Legacy-Editor-Pfad /world-element-edit?id= bleibt DAUERHAFT bestehen
// (docs/30 §8.4): formatAiMessage.tsx erzeugt diese Strings, und sie stecken in
// GESPEICHERTEN Chatverläufen — kein Redirect auf Zeit, ein Vertrag mit Altdaten.
//
// Die Rollback-Probe (QA/rollback-probe.mjs) prüft die andere Richtung gegen ein
// VORGÄNGER-dist und liest dafür redirect_vorwelle.faelle (RÜCKWÄRTS, unverändert).
// Der Routing-Test hier (worldRedirects.test.tsx) liest redirect_vorwelle.forward_faelle.

import { type ReactElement } from 'react';
import { Navigate, Route, useSearchParams, useLocation } from 'react-router-dom';

// /world-element-edit?id=<id>&type=<type>  ->  kanonisch /world/<type>/<id>.
// Ohne id: Anlege-Route der Kategorie (/world/<type>/new). Ohne type: der Typ
// steht am Element selbst; die Ziel-Route (WorldElementEditPage) löst ihn aus
// element.type auf, der '_'-Platzhalter im Pfad ist nur ein Segment-Füller.
function LegacyWorldElementRedirect(): ReactElement {
  const [sp] = useSearchParams();
  const id = sp.get('id');
  const type = sp.get('type');
  if (!id) {
    return <Navigate to={type ? `/world/${encodeURIComponent(type)}/new` : '/world'} replace />;
  }
  return (
    <Navigate
      to={`/world/${type ? encodeURIComponent(type) : '_'}/${encodeURIComponent(id)}`}
      replace
    />
  );
}

// Geteilte Routentabelle: wird von routes.tsx UND worldRedirects.test.tsx
// verwendet, damit die Testtabelle nicht von der echten Routentabelle abdriftet.
// KEIN /world/:type[/:id] hier — das sind ab E5c echte Routen (WorldSplit).
// P25-Verify: /spielbau?type=X trug bisher die Kategorie — der statische
// Navigate verwarf die Query (Alt-Deep-Links + der frühere interne Handoff
// landeten auf der Übersicht). Query durchreichen ist seit dem Guard-Fix in
// world-elements (kein Abprall-Handoff mehr auf /spielbau) schleifenfrei.
function SpielbauRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/world/spielbau', search }} replace />;
}

export const worldRedirectRoutes: ReactElement[] = [
  <Route key="wr-element-edit" path="/world-element-edit" element={<LegacyWorldElementRedirect />} />,
  <Route key="wr-world-tree" path="/world-tree" element={<Navigate to="/world?view=tree" replace />} />,
  <Route key="wr-spielbau" path="/spielbau" element={<SpielbauRedirect />} />,
];
